import { useContext } from 'react'
import { Textfit } from "react-textfitfix"
import _ from "lodash"

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import { PassImage } from '/components/editor/pass-image'
import useFontsReady from './use-fonts-ready'

const StripImage = () => {

  const { template, variables, model, passType, smartixPassType, scannerData, device } = useContext(PassContext)
  const fontsReady = useFontsReady()

  const defaultStripImage = dataSelector({ template, variables, path: "meta.images.strip" })
  const stampBalanceRaw = _.get(variables, "stamp.stamps.balance", 0)
  const stampBalance = Math.max(0, Number.parseInt(stampBalanceRaw, 10) || 0)
  const stampStripImage = _.get(scannerData, ["stamp_images", device, stampBalance])
  const fallbackStampStripImage = _.get(scannerData, ["stamp_images", device, 0])
  const stripImage = smartixPassType === "managed_stamp" ? (stampStripImage || fallbackStampStripImage || defaultStripImage) : defaultStripImage

  const primaryFields = template.primaryFields ? template.primaryFields : []

  const label = primaryFields.length ? dataSelector({ template: primaryFields[0], variables, path: "label" }) : ""
  const value = primaryFields.length ? dataSelector({ template: primaryFields[0], variables, path: "value" }) : ""

  const editPath = smartixPassType === "managed_stamp" ? "stamp-images" : "meta.images.strip"

  const stripColor = dataSelector({ template:model, variables, path: "stripColor" })
  const foregroundColor = dataSelector({ template:model, variables, path: "foregroundColor" })

  const styles = {
    stripTextColor: {
      color: stripImage ? (stripColor ? stripColor : "white") : foregroundColor
    }
  }

  return (
    <div className="primary"> {/* Primary text overlays the strip image */}

      <PopupEditor title="Strip Image" path={editPath}>
        {stripImage &&
          <>
            <PassImage src={stripImage} className="strip" />
            <div className="strip editable" />
          </>}
          <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", top: 0, right: 10, zIndex:99999 }} />
      </PopupEditor>

      {smartixPassType !== "managed_stamp" &&
        <>
          <PopupEditor title="Primary Fields" path="primaryFields" colors={{ label: stripColor ? "model.stripColor" : "white (fixed)", value: stripColor ? "model.stripColor" : "white (fixed)" }} maxFields={1}>
            <div className="item editable">
              {/* Primary text label is only shown for coupon and storeCard type */}
              {/* Where shown, the label comes AFTER the value field - hidden by CSS where not required*/}
              <Textfit key={`strip-value-${fontsReady ? "ready" : "pending"}`} mode="multi" className="value" style={styles.stripTextColor} min={12} max={60}>{value}</Textfit>
              {labelField({ styles, label, passType, fontsReady })}
            </div>
          </PopupEditor>
        </>}

    </div>)
}

export default StripImage

const labelField = ({ styles, label, passType, fontsReady }) => {
  if (["coupon", "storeCard"].includes(passType) && label.length) return <Textfit key={`strip-label-${fontsReady ? "ready" : "pending"}`} mode="single" className="label" style={styles.stripTextColor} min={10} max={20}>{label}</Textfit>
}
